import { Component, inject, input, output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IAsset } from 'src/app/core/interfaces/asset.interface'
import { CurrencyCode } from 'src/app/core/interfaces/currency.interface'
import { LegacyImageProcessorTypes } from 'src/app/core/interfaces/image.interface'
import { ImageSourceDirective } from 'src/app/core/directives/image-source.directive'
import { AssetPricePipe } from 'src/app/core/pipes/asset-price.pipe'
import { IconButtonModule } from '../icon-button/icon-button.module'
import { ColorSchemeDirective } from 'src/app/core/directives/color-scheme.directive'

@Component({
  selector: 'app-comparison-card',
  templateUrl: './comparison-card.component.html',
  styleUrls: ['./comparison-card.component.scss'],
  imports: [
    CommonModule,
    ImageSourceDirective,
    AssetPricePipe,
    IconButtonModule,
    ColorSchemeDirective,
  ],
})
export class ComparisonCardComponent {
  contactForPricing = $localize`:@@asset-card.price-when-hidden:Contact for Pricing`

  asset = input<IAsset>()
  currencyCode = input<CurrencyCode>(CurrencyCode.USD)
  defaultImage = input<string>('')

  clearClicked = output<void>()

  LegacyImageProcessorTypes = LegacyImageProcessorTypes
}
